<template>
  <div class="img-box uploader-box">
    <div class="img-item" v-for="(item, index) in list" :key="index">
      <img class="img" :src="item" alt="" @click="previewImg(index)">
      <img @click="delImgFn(index)" class="cancel-icon" src="./../assets/cancel.png" alt="">
    </div>
    <div v-if="list.length < count" class="upload-btn" @click.stop.prevent='uploaderFn'>
      <img class="camera-icon" src="./../assets/camera.png" alt="" />
      <div>添加照片</div>
    </div>
  </div>
</template>

<script>
import bridgeService from '@/lib/dsbridgeService';
import { ImagePreview } from 'vant';
import { uploadPic } from '@/api/weixin';

export default {
  name: 'Uploader',
  props: {
    // 可选择张数
    count: {
      type: Number,
      value: 1,
    },
    uploadImgList: {
      type: Array,
      value: [],
    },
  },
  computed: {
    list() {
      return this.uploadImgList || [];
    },
  },
  data() {
    return {
      // list: this.uploadImgList || [],
    };
  },
  methods: {
    // 上传图片后的回调
    uploaderFn() {
      let count = 1;
      const self = this;

      if (this.count > 1) {
        count = this.count - this.list.length;
      }

      if (this.$isInWxMP) {
        this.$wx.chooseImage({
          count, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success(res) {
            // tempFilePath可以作为img标签的src属性显示图片
            const { localIds, } = res;

            self.uploadImg(localIds, self);
          },
        });
      } else {
        bridgeService.multiImagePicker(count, 0.7, (res) => {
          const { resourcesUrl, filePath, } = res;

          const resourcesUrlArr = resourcesUrl.split(',');
          const filePathArr = filePath.split(',');

          filePathArr.forEach((element, i) => {
            this.list.push(`${resourcesUrlArr[i]}${element}`);
          });

          this.emitUploadFn();
        });
      }
    },
    // 图片上传
    // eslint-disable-next-line consistent-this
    uploadImg(localIds, self) {
      const { length, } = localIds;

      let uploadImgCount = 0;

      /* const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        message: '上传图片中……',
      }); */

      const upload = () => {
        self.$wx.uploadImage({
          localId: localIds[uploadImgCount],
          // eslint-disable-next-line no-loop-func
          success(res) {
            uploadImgCount += 1;
            const { serverId, } = res; // 返回图片的服务器端ID

            uploadPic({
              mediaId: serverId,
            }).then((result) => {
              if (result && result.code === 200) {
                const { resourcesUrl, filePath, } = result.data;

                self.list.push(`${resourcesUrl}${filePath}`);
              }

              if (uploadImgCount < length) {
                upload();
              } else {
                /* try {
                  if (toast) {
                    toast.clear();
                  }
                } catch (error) {
                  console.log(error);
                } */
              }
            });
          },
          fail() {
            self.$toast('图片上传出错');
          },
        });
      };

      upload();
    },
    // 回调函数
    emitUploadFn() {
      this.$emit('uploaderFn', this.list);
    },
    delImgFn(index) {
      this.list.splice(index, 1);
      this.emitUploadFn();
    },
    previewImg(index) {
      ImagePreview({
        images: this.list,
        showIndex: true,
        loop: false, // 是否循环播放
        startPosition: index,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.img-box {
  @include flex();

  flex-wrap: wrap;
  padding: 5px 10px 0;

  .img-item {
    position: relative;
    margin: 0 5px 10px;

    .cancel-icon {
      position: absolute;
      top: -13px;
      right: -10px;
      width: 18px;
      padding: 5px;
    }
  }

  .img {
    width: 75px;
    height: 75px;
    border-radius: 8px;
    vertical-align: top;
    background-color: $background-color-2;
  }

  .upload-btn {
    @include font(11px, 16px, $info-text-color, center);

    width: 75px;
    height: 75px;
    background-color: $background-color-2;
    border-radius: $regular-border-radius;
    margin: 0 5px 10px;

    .camera-icon {
      margin: 15px 0 4px;
      width: 24px;
    }
  }
}
</style>

<style lang="scss">
.uploader-box {
  .van-uploader__preview {
    margin: 0 5px 10px;

    .van-image__img {
      width: 75px;
      height: 75px;
      border-radius: 8px;
    }
  }

  .van-uploader__preview-image {
    overflow: visible;
  }

  .van-uploader__preview-delete {
    width: 18px;
    height: 18px;
    opacity: 0;
    top: -8px;
    right: -5px;
  }
}
</style>
